export var CardStatus;
(function (CardStatus) {
    CardStatus[CardStatus["Valid"] = 1] = "Valid";
    CardStatus[CardStatus["Expired"] = 2] = "Expired";
    CardStatus[CardStatus["NoExist"] = 3] = "NoExist";
})(CardStatus || (CardStatus = {}));
